import { render, staticRenderFns } from "./vmDetaile.vue?vue&type=template&id=32ba5d48&scoped=true"
import script from "./vmDetaile.vue?vue&type=script&lang=ts"
export * from "./vmDetaile.vue?vue&type=script&lang=ts"
import style0 from "./vmDetaile.vue?vue&type=style&index=0&id=32ba5d48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba5d48",
  null
  
)

export default component.exports